import script from "./zyxds.vue?vue&type=script&setup=true&lang=js"
export * from "./zyxds.vue?vue&type=script&setup=true&lang=js"

import "./zyxds.vue?vue&type=style&index=0&id=5e49c093&lang=less"

const __exports__ = script;

export default __exports__